import { useEffect, useRef } from "react";

// A soft point of light that drifts slowly through the frame: follow rather than focus.
// Layered slow sines (never a repeating loop the eye can learn), it rests in the middle band, away from the words,
// and now and then grows fainter before returning.
export default function FollowDot({ visible, speed = 1, size = 10, accent = "#ffffff" }) {
  const ref = useRef(null);
  useEffect(() => {
    let raf, t0 = performance.now();
    const seed = Math.random() * 100;
    const tick = (now) => {
      const t = ((now - t0) / 1000) * speed + seed;
      const x = 50 + 30 * Math.sin(t * 0.071) + 9 * Math.sin(t * 0.163 + 1.3) + 3 * Math.sin(t * 0.41);
      const y = 42 + 13 * Math.sin(t * 0.053 + 0.7) + 5 * Math.sin(t * 0.137 + 2.1);
      const fade = 0.62 + 0.38 * Math.max(0, Math.sin(t * 0.045)); // occasionally becomes more subtle
      if (ref.current) {
        ref.current.style.transform = `translate3d(calc(${x}vw - 50%), calc(${y}vh - 50%), 0)`;
        ref.current.style.opacity = visible ? String(fade) : "0";
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [visible, speed]);
  return (
    <div ref={ref} aria-hidden className="absolute top-0 left-0 pointer-events-none" data-testid="immersion-dot"
      style={{ width: size, height: size, borderRadius: "50%", background: "#fff", opacity: 0, transition: "opacity 2.5s ease",
        boxShadow: `0 0 ${size * 1.6}px ${size * 0.5}px ${accent}66, 0 0 ${size * 4}px ${size}px rgba(255,255,255,0.12)`, willChange: "transform, opacity" }} />
  );
}
